/**
 * Browser-safe OpenAI SDK stub.
 * Replaces the `openai` package in Vite browser builds.
 *
 * openaiProvider.isAvailable() returns false when VITE_OPENAI_API_KEY is not
 * set, so generate()/stream() are never called in the browser. This stub
 * prevents the OpenAI v6 constructor from throwing "Missing credentials" /
 * "running in a browser-like environment" at module-scope initialisation.
 *
 * Trust-boundary note: real OpenAI API calls must only be made server-side.
 */

const ERR = () =>
  new Error("OpenAI SDK is not available in the browser. Use the server API.");

class CompletionsStub {
  async create(_params: unknown): Promise<never> {
    throw ERR();
  }
}

class ChatStub {
  completions = new CompletionsStub();
}

class ImagesStub {
  async generate(_params: unknown): Promise<never> {
    throw ERR();
  }
}

class OpenAIStub {
  chat   = new ChatStub();
  images = new ImagesStub();
  constructor(_opts?: unknown) {}
}

export default OpenAIStub;
export { OpenAIStub as OpenAI };
